// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_n6-1";
export var rowFirst = "_n6-3";
export var rowLast = "_n6-5";
export var rowMiddle = "_n6-4";
export var ticketListScroll = "_n6-2";
export var ticketStack = "_n6-0";